"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactGoogleCharts = require("react-google-charts");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
//Example format to render a particular country graph(Pass it in options prop)
// {
//     region: 'IN',
//     displayMode: 'regions',
//     resolution: 'provinces',
//     colorAxis: { colors: ['blue', 'red'] }
// }

const GeoChart = props => {
  const {
    geoChartData = [[]],
    geoChartOptions = {},
    geoChartHeight = '400px',
    geoChartWidth = '100%'
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactGoogleCharts.Chart, {
    options: geoChartOptions,
    chartEvents: [{
      eventName: 'select',
      callback: ({
        chartWrapper
      }) => {
        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();
        if (selection.length === 0) return;
        const region = geoChartData[selection[0].row + 1];
        console.log('Selected : ' + region);
      }
    }],
    chartType: "GeoChart",
    width: geoChartWidth,
    height: geoChartHeight,
    data: geoChartData
  });
};
var _default = exports.default = GeoChart;
module.exports = exports.default;
module.exports.default = exports.default;